import { MultiSelectFilter } from '~/app/pages/WaitingList/Header/Filters/MultiSelectFilter'
import { selectStatusValues } from '~/store/slices/surgeonSchedulerFilterSlice'
import { useStore } from '~/store/store'
import { usePractitionerStatusDefinitions } from '~/storm'

export const useStatusOptions = () => {
    const statuses = usePractitionerStatusDefinitions()
    return statuses.map(status => ({
        label: `${status.title} (${status.label})`,
        value: status.code,
    }))
}

export const StatusFilter = () => {
    const { toggleFilteredBySelection, removeAllFilterByType } = useStore(state => state.surgeonSchedulerFilters.actions)
    const statusValues = useStore(selectStatusValues)
    const statusOptions = useStatusOptions()

    return (
        <MultiSelectFilter
            options={statusOptions}
            selectedValues={statusValues}
            placeholder="Aktiviteter"
            filterType="status"
            toggleFilteredBySelection={toggleFilteredBySelection}
            removeAllFilterByType={removeAllFilterByType}
        />
    )
}
